export const API_URL = 'https://my0zhkospc.execute-api.us-east-1.amazonaws.com/dev/pickticket_backend';
